/**
 * One rule for page and API paths in a feedback report (SA-1304): a segment that is a UUID, a
 * number or a record number (`Q-0142`, `RS-142`) becomes `:id`, kept in order as `params`. The
 * query string and fragment are dropped; a page's allowed query keys are read separately.
 */

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i
const NUMBER = /^\d+$/
const RECORD_NUMBER = /^[A-Z]{1,4}-\d+$/

export function isIdSegment(segment: string): boolean {
  return UUID.test(segment) || NUMBER.test(segment) || RECORD_NUMBER.test(segment)
}

export function templatePath(path: string): { template: string; params: string[] } {
  const bare = path.split(/[?#]/, 1)[0]
  const params: string[] = []
  const segments = bare
    .split('/')
    .filter((segment) => segment !== '')
    .map((segment) => {
      if (!isIdSegment(segment)) return segment
      params.push(segment)
      return ':id'
    })
  return { template: `/${segments.join('/')}`, params }
}
